
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import UserListAvatar from "@/components/users/UserListAvatar.vue";
import UsersGroupMosaicView from "@/components/users/UsersGroupMosaicView.vue";
import { Getter } from "vuex-class";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component({
  components: {
    UserListAvatar,
    UsersGroupMosaicView,
  },
})
export default class UsersGroup extends Vue {
  @Prop({default: 0})
  public totalUsers: number;

  @Prop({default: []})
  public usersGroups: object[];

  @Prop({default: false})
  public loading: boolean;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  @Getter private envCompanyId: number|null;

  private pagination: any = {
    sortDesc: [false],
    sortBy: [""],
    search: "",
    page: 1,
    itemsPerPage: 20,
  };

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  private headers: object[] = [
    {value: "name", sortable: true},
    {value: "users", sortable: false},
    {value: "updatedAt", sortable: true},
  ];
  private mosaicView: boolean = true;
  private search: string = null;

  @Watch("pagination", { deep: true })
  public handlerPagination() {
    this.$emit("reset", this.pagination);
  }

  private mounted() {
    this.$emit("reset", this.pagination);
  }

  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.searchHandler();
    }
  }

  private searchHandler(): void {
    this.pagination.search = this.search;
    this.pagination.page = 1;
  }

  private clickItem(data) {
      this.$router.push({name: "user-group", params: {id: data.id}});
  }

  private openCreate() {
    this.$emit("open-create-dialog");
  }
}
